var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "v-application v-application--is-ltr",
        "min-width": "600px",
        "max-width": "800px",
        fullscreen: !_vm.$vuetify.breakpoint.mdAndUp,
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("E-Mail senden")]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "mt-8" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "h5 mt-1 mb-3 pr-0", attrs: { cols: "2" } },
                    [_vm._v("Empfänger")]
                  ),
                  _vm._v(" "),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.emailAddress))]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "h5 mt-3", attrs: { cols: "2" } },
                    [_vm._v("Betreff")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "10" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Betreff",
                          outlined: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.mailSubject,
                          callback: function ($$v) {
                            _vm.mailSubject = $$v
                          },
                          expression: "mailSubject",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "h5 mt-3", attrs: { cols: "2" } },
                    [_vm._v("Text")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "10" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          rows: "10",
                          label: "Text",
                          outlined: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.mailBody,
                          callback: function ($$v) {
                            _vm.mailBody = $$v
                          },
                          expression: "mailBody",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "send-mail",
                  attrs: {
                    disabled:
                      !_vm.mailSubject.trim().length ||
                      !_vm.mailBody.trim().length,
                    color: "success",
                    depressed: "",
                  },
                  on: { click: _vm.sendMail },
                },
                [_vm._v("\n                Absenden\n            ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.isOpen = false
                    },
                  },
                },
                [_vm._v("\n                Abbrechen\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }